import { Box, ColorOptions, TextNew } from '@jfs/ui-new'
import { useState } from 'react'
import { TableComponent } from '../TableComponent'
import { AccordionItem } from './AccordionItem'
import { styles } from './styles'

interface AccordionInterface {
  hide?: boolean
  onRefund: (id: string) => void
  data: any
  onPaymentHistory: (trxId: string, index: number) => void
  loading: any
  type: number
}

export const Accordion = ({ hide, onRefund, data, onPaymentHistory, loading, type }: AccordionInterface) => {
  const [selectedIndex, setSelectedIndex] = useState(-1)

  if (hide) {
    return null
  }

  const renderItem = ({ item, index }: any) => {
    return (
      <AccordionItem
        data={item}
        index={index}
        onRefund={onRefund}
        onPaymentHistory={(trxId) => onPaymentHistory(trxId, index)}
        loading={loading}
        selectedIndex={selectedIndex}
        onPress={() => setSelectedIndex(index)}
        type={type}
      />
    )
  }

  return (
    <Box>
      <Box ph={24} paddingBottom={16}>
        <TextNew type="body16" color="BLACK_21" fontFamily="jiotype-bold">
          Transaction Details
        </TextNew>
      </Box>
      <TableComponent
        value={''} //Routes value
        canFetchMore={false}
        ListContent={data}
        hide={false}
        isCustom={true}
        RenderCustomElement={renderItem}
        contentContainerStyle={styles.flatlist}
        keyboardDismissMode="on-drag"
        keyboardShouldPersistTaps={'always'}
        extraData={selectedIndex}
        ListHeaderComponent={ListHeaderComponent}
        keyExtractor={(item) => String(item.id)}
      />
    </Box>
  )
}

const ListHeaderComponent = () => {
  return (
    <Box bg={'BLUE_0A' as ColorOptions} pv={12} ph={24} flexDirection="row">
      <Box f={0.3}>
        <TextNew {...styles.listHeaderStyle}>{'Txn Number'}</TextNew>
      </Box>
      <Box f={0.3}>
        <TextNew {...styles.listHeaderStyle} textAlign="left">
          {'Date'}
        </TextNew>
      </Box>
      <Box f={0.2}>
        <TextNew {...styles.listHeaderStyle} textAlign="left">
          {'Amount'}
        </TextNew>
      </Box>
      <Box f={0.2}>
        <TextNew {...styles.listHeaderStyle} textAlign="left">
          {'Status'}
        </TextNew>
      </Box>
    </Box>
  )
}
